import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { ToastContainer, Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_ENDPOINTS } from "../../../config/api";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error("Email and password are required fields.", {
        position: "top-right",
        autoClose: 3000,
        transition: Slide,
      });
      return;
    }

    try {
      const res = await axios.post(API_ENDPOINTS.AUTH.LOGIN, formData);

      if (res.data.error) {
        toast.error(res.data.message || "Login failed", {
          position: "top-right",
          autoClose: 3000,
          transition: Slide,
        });
        return;
      }

      const { userId, message, status } = res.data;
      const successMessage = message || "Logged in successfully!";
      const storage = rememberMe ? localStorage : sessionStorage;
      const resolvedStatus = status || "approved";

      if (resolvedStatus === "disapproved") {
        toast.error("Your account has been disapproved by admin. Please contact support.", {
          position: "top-right",
          autoClose: 5000,
          transition: Slide,
        });
        return;
      }

      if (resolvedStatus === "pending") {
        toast.warning("Account pending approval - Read-only access granted.", {
          position: "top-right",
          autoClose: 5000,
          transition: Slide,
        });
      } else {
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          transition: Slide,
        });
      }

      storage.setItem("userId", userId);
      storage.setItem("userStatus", resolvedStatus);

      navigate(`/dashboard/${userId}`, {
        state: { toastMessage: resolvedStatus === "pending" ? "Account pending approval - Read-only access granted." : successMessage, userStatus: resolvedStatus },
      });
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed", {
        position: "top-right",
        autoClose: 3000,
        transition: Slide,
      });
    }
  };

  return (
    <div
      style={{
        backgroundImage: "url('/images/Login.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Row>
          <Col md={6} lg={5}>
            <div
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.85)",
                padding: "2.5rem",
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h2 className="mb-4" style={{ color: "#2c3e50", fontWeight: "bold" }}>
                Volunteer Login
              </h2>

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label style={{ fontWeight: "600", color: "#555" }}>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    style={{
                      padding: "12px",
                      borderRadius: "6px",
                      border: "1px solid #ddd",
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label style={{ fontWeight: "600", color: "#555" }}>Password</Form.Label>
                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      style={{
                        padding: "12px",
                        paddingRight: "45px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#666",
                        fontSize: "16px",
                      }}
                    >
                      {showPassword ? "👁️" : "👁️"}
                    </button>
                  </div>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Check
                    type="checkbox"
                    id="rememberMe"
                    label="Remember me"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    style={{ fontWeight: "500", color: "#555" }}
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "6px",
                    backgroundColor: "#3498db",
                    border: "none",
                    fontWeight: "600",
                    fontSize: "1rem",
                  }}
                >
                  Login
                </Button>
              </Form>

              <p className="mt-4 text-center" style={{ color: "#666" }}>
                Need to submit your information?{" "}
                <Link to="/Registration" style={{ color: "#3498db", textDecoration: "none" }}>
                  Register here
                </Link>
              </p>
              <p className="text-center" style={{ color: "#666" }}>
                <Link to="/" style={{ color: "#666", textDecoration: "none", fontSize: "0.9rem" }}>
                  ← Back to Home
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default Login;